import { createContext, useContext } from "react";
import type { ProfilePhotoState } from "../services/profilePhotoService";

export const ProfilePhotoContext = createContext<ProfilePhotoState | null>(null);
export const useProfilePhoto = () => useContext(ProfilePhotoContext);
